/* @flow */
import * as React from 'react';
import classNames from 'classnames';
import moment from 'moment';
import Checkbox from 'components/Checkbox';
import ErrorAwareImage from 'components/ErrorAwareImage';
import protonesUtils from 'utils/protones';
import { withTranslation } from 'react-i18next';
import styles from './styles.module.scss';

import type { Translate, Worklist } from 'types';

type Props = {
  worklist: Worklist,
  isSelected?: boolean,
  isSelectable?: boolean,
  isPlaying?: boolean,
  isSelected?: boolean,
  isUnplayable?: boolean,
  onCheckboxClick?: (index: number) => mixed,
  onNameClick: string => mixed,
  onChannelClick: string => mixed,
  onAreaClick: string => mixed,
  onProductionClick: string => mixed,
  onEpisodeClick: string => mixed,
  onItemsCountClick: string => mixed,
  onCreateDateClick: string => mixed,
  onModifiedDateClick: string => mixed,
  onClick: any => mixed,
  actionButtons: React.Node,
  isLoading?: boolean,
  t: Translate,
};

type State = {
  isRowExpanded: boolean,
  isDetailsExpanded: boolean,
};

class WorklistRow extends React.PureComponent<Props, State> {
  state = {
    isRowExpanded: false,
    isDetailsExpanded: false,
  };

  componentDidUpdate(prevProps: Props) {
    if (!prevProps.isLoading && this.props.isLoading) {
      this.setState({ isRowExpanded: false, isDetailsExpanded: false });
    }
  }

  _handleRowExpandClick = () => {
    this.setState({ isRowExpanded: !this.state.isRowExpanded });
  };

  _handleDetailsExpandClick = () => {
    this.setState({ isDetailsExpanded: !this.state.isDetailsExpanded });
  };

  render() {
    const {
      isSelected,
      isSelectable,
      onClick,
      onNameClick,
      onChannelClick,
      onAreaClick,
      onProductionClick,
      onEpisodeClick,
      onItemsCountClick,
      onCreateDateClick,
      onModifiedDateClick,
      onCheckboxClick,
      isLoading,
      actionButtons,
      worklist,
      t,
    } = this.props;
    const { name, usage, itemsCount, coverUrl, createDate, modifiedDate } = worklist;
    const channelName = usage && usage.channel && usage.channel.name;
    const area = usage && usage.production && usage.production.area && usage.production.area.name;
    const production = usage && usage.production && usage.production.name;
    const episode = usage && usage.episode;
    // $FlowFixMe

    const rowClassName = this.state.isRowExpanded ? styles.expandedRow : styles.row;
    const loadingClassName = isLoading ? styles.loadingRow : undefined;
    // $FlowFixMe
    const oldestMedia = protonesUtils.getOldestMedia(this.props.medias);
    return (
      <div className={classNames(rowClassName, loadingClassName)} onClick={onClick}>
        <div className={isSelected ? styles.selectedRow : ''}>
          <div className={styles.topRow}>
            {isSelectable && (
              <div className={styles.checkbox}>
                <Checkbox onClick={onCheckboxClick} small={true} checked={isSelected} />
              </div>
            )}
            <div
              className={styles.cover}
              onClick={
                // $FlowFixMe
                oldestMedia !== undefined ? () => this.props.onMediaClick(oldestMedia) : undefined
              }
            >
              <ErrorAwareImage
                // $FlowFixMe
                src={coverUrl}
                className={styles.albumImage}
                alt={t('WORKLIST_COVER')}
              />
            </div>
            <div className={styles.name} onClick={onNameClick}>
              {name}
            </div>
            <div className={styles.channelName} onClick={onChannelClick}>
              {channelName}
            </div>
            <div className={styles.area} onClick={onAreaClick}>
              {area}
            </div>
            <div className={styles.production} onClick={onProductionClick}>
              {production}
            </div>
            <div className={styles.episode} onClick={onEpisodeClick}>
              {episode}
            </div>
            <div className={styles.number} onClick={onItemsCountClick}>
              {itemsCount}
            </div>
            <div className={styles.createDate} onClick={onCreateDateClick}>
              {moment(createDate).format('YYYY / MM / DD')}
            </div>
            <div className={styles.modifiedDate} onClick={onModifiedDateClick}>
              {moment(modifiedDate).format('YYYY / MM / DD')}
            </div>
            <div className={styles.actions}>{actionButtons}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(WorklistRow);
